import { action, createRequestTypes } from './base';

export const userActionTypes = {
  REQUEST_OTP: createRequestTypes('REQUEST_OTP'),
  VERIFY_OTP: createRequestTypes('VERIFY_OTP'),
  GET_USER_PROFILE: createRequestTypes('GET_USER_PROFILE'),
  LOGOUT_USER: createRequestTypes('LOGOUT_USER'),
  RESEND_OTP: createRequestTypes('RESEND_OTP'),
  SIGN_UP_USER: createRequestTypes('SIGN_UP_USER'),
  SIGN_UP_USER_FAST: createRequestTypes('SIGN_UP_USER_FAST'),
  VERIFY_SIGNUP_OTP: createRequestTypes('VERIFY_SIGNUP_OTP'),
  REQUEST_CALLBACK: createRequestTypes('REQUEST_CALLBACK'),
  TOGGLE_LOGIN_MODAL: createRequestTypes('TOGGLE_LOGIN_MODAL'),
  TOGGLE_OFFER_MODAL: createRequestTypes('TOGGLE_OFFER_MODAL'),
  GET_USERS: createRequestTypes('GET_USERS'),
  CREATE_USER: createRequestTypes('CREATE_USER'),
  UPDATE_USER: createRequestTypes('UPDATE_USER'),
  UPDATE_MY_USER: createRequestTypes('UPDATE_MY_USER'),
  GET_ROLES: createRequestTypes('GET_ROLES'),
  UPDATE_PERMISSION: createRequestTypes('UPDATE_PERMISSION'),
  GET_PERMISSIONS: createRequestTypes('GET_PERMISSIONS'),
  INIT_PERMISSION: createRequestTypes('INIT_PERMISSION'),
  SWITCH_BUSINESS_UNIT: createRequestTypes('SWITCH_BUSINESS_UNIT'),
  UPDATE_ORG: createRequestTypes('UPDATE_ORG'),
  GET_ORG: createRequestTypes('GET_ORG'),
  CREATE_ROLE: createRequestTypes('CREATE_ROLE'),
  GET_PENDING_ACTIONS: createRequestTypes('GET_PENDING_ACTIONS'),
};

/**
 * @param user
 * @param toggleOfferModalState
 * @param page
 * @param keyword
 * @param isVerified
 * @param orgId
 * @param limit
 * @param tenantId
 * @param payload
 * @param callback
 * @param updateRoleLoading
 * @param type
 * @param getPendingActionsLoading
 * @param pendingActions
 * @param getUserProfileLoading
 */
class UserActions {
  /**
   *
   * @return {{type: *}}
   */
  getUserProfile = (callback) => action(userActionTypes.GET_USER_PROFILE.REQUEST, { callback })

  /**
   *
   * @param getUserProfileLoading
   * @return {{type: *}}
   */
  getUserProfileLoading = (getUserProfileLoading) => action(
    userActionTypes.GET_USER_PROFILE.LOADING, {
      getUserProfileLoading,
    },
  )

  /**
   *
   * @param user
   * @return {{type: *}}
   */
  setUserProfile = (user) => action(userActionTypes.GET_USER_PROFILE.SUCCESS, {
    user,
  })

  /**
   * @param requestType
   * @param payload
   * @param requestValue
   * @return {{type: *}}
   */
  requestOtp = (payload) => action(userActionTypes.REQUEST_OTP.REQUEST, {
    payload,
  })

  /**
   *
   * @param requestOtpLoading
   * @return {{type: *}}
   */
  requestOtpLoading = (requestOtpLoading) => action(userActionTypes.REQUEST_OTP.LOADING, {
    requestOtpLoading,
  })

  /**
   *
   * @param requestOtpResponse
   * @param requestType
   * @param requestValue
   * @return {{type: *}}
   */
  requestOtpSuccess = (requestOtpResponse) => action(userActionTypes.REQUEST_OTP.SUCCESS, {
    requestOtpResponse,
  })

  /**
   *
   * @param otpError
   * @return {{type: *}}
   */
  requestOtpError = (otpError) => action(userActionTypes.REQUEST_OTP.ERROR, {
    otpError,
  })

  /**
   *
   * @param payload
   * @return {{type: *}}
   */
  verifyOtp = (payload) => action(userActionTypes.VERIFY_OTP.REQUEST, {
    payload,
  })

  /**
   *
   * @param verifyOtpLoading
   * @return {{type: *}}
   */
  verifyOtpLoading = (verifyOtpLoading) => action(userActionTypes.VERIFY_OTP.LOADING, {
    verifyOtpLoading,
  })

  /**
   *
   * @param userInfo
   * @return {{type: *}}
   */
  verifyOtpSuccess = (userInfo) => action(userActionTypes.VERIFY_OTP.SUCCESS, {
    userInfo,
  })

  /**
   *
   * @param error
   * @return {{type: *}}
   */
  verifyOtpError = (error) => action(userActionTypes.VERIFY_OTP.ERROR, {
    error,
  })

  /**
   *
   * @return {{type: *}}
   */
  logoutUser = () => action(userActionTypes.LOGOUT_USER.REQUEST, {})

  /**
   *
   * @param logoutUserLoading
   * @return {{type: *}}
   */
  logoutUserLoading = (logoutUserLoading) => action(userActionTypes.LOGOUT_USER.LOADING, {
    logoutUserLoading,
  })

  /**
   *
   * @return {{type: *}}
   */
  logoutUserSuccess = () => action(userActionTypes.LOGOUT_USER.SUCCESS, {})

  /**
   * @return {{type: *}}
   * @param payload
   */
  signupUser = (payload) => action(userActionTypes.SIGN_UP_USER.REQUEST, {
    payload,
  })

  /**
   * @param signupUserLoading
   * @param signUpUserLoading
   * @return {{type: *}}
   */
  signupUserLoading = (signupUserLoading) => action(userActionTypes.SIGN_UP_USER.LOADING, {
    signupUserLoading,
  })

  /**
   *
   * @param signupUserInfo
   * @return {{type: *}}
   */
  signupUserSuccess = (signupUserInfo) => action(userActionTypes.SIGN_UP_USER.SUCCESS, {
    signupUserInfo,
  })

  /**
   *
   * @param signupError
   * @return {{type: *}}
   */
  signupUserError = (signupError) => action(userActionTypes.SIGN_UP_USER.ERROR, {
    signupError,
  })

  /**
   * @return {{type: *}}
   * @param payload
   */
   signupUserFast = (payload) => action(userActionTypes.SIGN_UP_USER_FAST.REQUEST, {
     payload,
   })

  /**
   *
   * @param signupUserLoadingFast
   * @return {{type: *}}
   */
  signupUserFastLoading = (signupUserLoadingFast) => action(userActionTypes.SIGN_UP_USER_FAST.LOADING, {
    signupUserLoadingFast,
  })

  /**
   * @param signupUserInfoFast
   * @param signupUserInfo
   * @return {{type: *}}
   */
  signupUserFastSuccess = (signupUserInfoFast) => action(userActionTypes.SIGN_UP_USER_FAST.SUCCESS, {
    signupUserInfoFast,
  })

  /**
   *
   * @param signupError
   * @return {{type: *}}
   */
  signupUserFastError = (signupError) => action(userActionTypes.SIGN_UP_USER_FAST.ERROR, {
    signupError,
  })

  /**
   *
   * @param payload
   * @return {{type: *}}
   */
  verifySignupOtp = (payload) => action(userActionTypes.VERIFY_SIGNUP_OTP.REQUEST, {
    payload,
  })

  /**
   *
   * @param verifySignupOtpLoading
   * @return {{type: *}}
   */
  verifySignupOtpLoading = (verifySignupOtpLoading) => action(userActionTypes.VERIFY_SIGNUP_OTP.LOADING, {
    verifySignupOtpLoading,
  })

  /**
   *
   * @param userInfo
   * @return {{type: *}}
   */
  verifySignupOtpSuccess = (userInfo) => action(userActionTypes.VERIFY_SIGNUP_OTP.SUCCESS, {
    userInfo,
  })

  /**
   *
   * @param verifySignupOtpError
   * @return {{type: *}}
   */
  verifySignupOtpError = (verifySignupOtpError) => action(userActionTypes.VERIFY_SIGNUP_OTP.ERROR, {
    verifySignupOtpError,
  })

  /**
   * @return {{type: *}}
   * @param sessionId
   */
  resendOtp = (sessionId) => action(userActionTypes.RESEND_OTP.REQUEST, {
    sessionId,
  })

  /**
   *
   * @param resendOtpLoading
   * @return {{type: *}}
   */
  resendOtpLoading = (resendOtpLoading) => action(userActionTypes.RESEND_OTP.LOADING, {
    resendOtpLoading,
  })

  /**
   *
   * @return {{type: *}}
   */
  resendOtpSuccess = () => action(userActionTypes.RESEND_OTP.SUCCESS, {})

  /**
   *
   * @type {{type: *}}
   */
  requestCallback = (payload) => action(userActionTypes.REQUEST_CALLBACK.REQUEST, {
    payload,
  })

  /**
   *
   * @param requestCallbackLoading
   * @return {{type: *}}
   */
  requestCallbackLoading = (requestCallbackLoading) => action(userActionTypes.REQUEST_CALLBACK.LOADING, {
    requestCallbackLoading,
  })

  /**
   *
   * @param showLoginModal
   * @return {{type: *}}
   */
  toggleLoginModal = (showLoginModal) => action(userActionTypes.TOGGLE_LOGIN_MODAL.REQUEST, {
    showLoginModal,
  })

  /**
   *
   * @return {{type: *}}
   */
  toggleLoginModalSuccess = () => action(userActionTypes.TOGGLE_LOGIN_MODAL.SUCCESS, {})

  /**
   *
   * @param {*} toggleOfferModalState
   * @return
   */
  toggleOfferModal = (toggleOfferModalState) => action(userActionTypes.TOGGLE_OFFER_MODAL.REQUEST, {
    toggleOfferModalState,
  })

  /**
   *
   * @param {*} page
   * @param {*} orgId
   * @param {*} tenantId
   * @return
   */
  getUsers = (page, orgId, tenantId) => action(userActionTypes.GET_USERS.REQUEST, {
    page, orgId, tenantId,
  });

  /**
   * @param getUsersLoading
   * @param getTenantsLoading
   * @return {{type: *}}
   */
   getUsersLoading = (getUsersLoading) => action(userActionTypes.GET_USERS.LOADING, {
     getUsersLoading,
   })

  /**
   * @param users
   * @param tenants
   * @return {{type: *}}
   */
  getUsersSuccess = (users) => action(userActionTypes.GET_USERS.SUCCESS, {
    users,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
     createUser = (payload, callback) => action(userActionTypes.CREATE_USER.REQUEST, {
       payload,
       callback,
     });

    /**
     *
     * @param createUserLoading
     * @return {{type: *}}
     */
    createUserLoading = (createUserLoading) => action(userActionTypes.CREATE_USER.LOADING, {
      createUserLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    updateRole = (payload, callback) => action(userActionTypes.UPDATE_PERMISSION.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} updateRoleLoading
     * @return
     */
    updateRoleLoading = (updateRoleLoading) => action(userActionTypes.UPDATE_PERMISSION.LOADING, {
      updateRoleLoading,
    })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createRole = (payload, callback) => action(userActionTypes.CREATE_ROLE.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param createRoleLoading
   * @return {{type: *}}
   */
  createRoleLoading = (createRoleLoading) => action(userActionTypes.CREATE_ROLE.LOADING, {
    createRoleLoading,
  })

    /**
     * @param {*} page
     * @param tenantId
     * @param roleId
     * @return
     */
    getPermissions = (page, tenantId, roleId) => action(userActionTypes.GET_PERMISSIONS.REQUEST, {
      page,
      tenantId,
      roleId,
    });

    /**
     * @param getPermissionsLoading
     * @param getUsersLoading
     * @return {{type: *}}
     */
     getPermissionsLoading = (getPermissionsLoading) => action(userActionTypes.GET_PERMISSIONS.LOADING, {
       getPermissionsLoading,
     })

     /**
      * @param permissions
      * @param permission
      * @return {{type: *}}
      */
     getPermissionsSuccess = (permissions) => action(userActionTypes.GET_PERMISSIONS.SUCCESS, {
       permissions,
     })

     /**
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
       updateUser = (payload, callback) => action(userActionTypes.UPDATE_USER.REQUEST, {
         payload,
         callback,
       });

       /**
        * @param updateUserLoading
        * @param createSellerLoading
        * @return {{type: *}}
        */
      updateUserLoading = (updateUserLoading) => action(userActionTypes.UPDATE_USER.LOADING, {
        updateUserLoading,
      })

      /**
       * @param payload
       * @param callback
       * @return {{type: *}}
       */
      updateMyUser = (payload, callback) => action(userActionTypes.UPDATE_MY_USER.REQUEST, {
        payload,
        callback,
      });

      /**
       * @param updateUserLoading
       * @param updateMyUserLoading
       * @param createSellerLoading
       * @return {{type: *}}
       */
     updateMyUserLoading = (updateMyUserLoading) => action(userActionTypes.UPDATE_MY_USER.LOADING, {
       updateMyUserLoading,
     })

     /**
      * @param {*} page
      * @param {*} orgId
      * @param tenantDepartmentId
      * @param {*} tenantId
      * @return
      */
  getRoles = (tenantId, tenantDepartmentId) => action(userActionTypes.GET_ROLES.REQUEST, {
    tenantId, tenantDepartmentId,
  });

  /**
   * @param getRolesLoading
   * @return {{type: *}}
   */
   getRolesLoading = (getRolesLoading) => action(userActionTypes.GET_ROLES.LOADING, {
     getRolesLoading,
   })

  /**
   * @param users
   * @param roles
   * @param tenants
   * @return {{type: *}}
   */
  getRolesSuccess = (roles) => action(userActionTypes.GET_ROLES.SUCCESS, {
    roles,
  })

  /**
   *
   * @param tenantId
   * @param roleId
   * @return {{type: *}}
   */
  initPermissions = (tenantId, roleId) => action(userActionTypes.INIT_PERMISSION.REQUEST, {
    tenantId, roleId,
  })

  /**
   *
   * @param initPermissionsLoading
   * @return {{type: *}}
   */
  initPermissionsLoading = (initPermissionsLoading) => action(userActionTypes.INIT_PERMISSION.LOADING, {
    initPermissionsLoading,
  })

  /**
   * @param tenantId
   * @param callback
   * @return {{type: *}}
   */
  switchBusinessUnit = (tenantId, callback) => action(userActionTypes.SWITCH_BUSINESS_UNIT.REQUEST, {
    tenantId, callback,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateOrg = (payload, callback) => action(userActionTypes.UPDATE_ORG.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param updateOrgLoading
   * @return {{type: *}}
   */
  updateOrgLoading = (updateOrgLoading) => action(userActionTypes.UPDATE_ORG.LOADING, {
    updateOrgLoading,
  })

  /**
   *
   * @param {*} page
   * @param {*} orgId
   * @param {*} tenantId
   * @return
   */
   getOrg = (orgId) => action(userActionTypes.GET_ORG.REQUEST, {
     orgId,
   });

   /**
    * @param getOrgLoading
    * @return {{type: *}}
    */
    getOrgLoading = (getOrgLoading) => action(userActionTypes.GET_ORG.LOADING, {
      getOrgLoading,
    })

    /**
     * @param users
     * @param org
     * @param tenants
     * @return {{type: *}}
     */
     getOrgSuccess = (org) => action(userActionTypes.GET_ORG.SUCCESS, {
       org,
     })

  /**
   * @param type
   * @param limit
   * @param page
   * @param actionType
   * @param callback
   * @return {{type: *}}
   */
  getPendingActions = (actionType, limit, page, callback) => action(userActionTypes.GET_PENDING_ACTIONS.REQUEST, {
    actionType, limit, page, callback,
  })

  /**
   *
   * @param getPendingActionsLoading
   * @return {{type: *}}
   */
  getPendingActionsLoading = (getPendingActionsLoading) => action(userActionTypes.GET_PENDING_ACTIONS.LOADING, {
    getPendingActionsLoading,
  })

  /**
   *
   * @param pendingActions
   * @return {{type: *}}
   */
  getPendingActionsSuccess = (pendingActions) => action(userActionTypes.GET_PENDING_ACTIONS.SUCCESS, {
    pendingActions,
  })
}
export default new UserActions();
